<template>
  <EnrollExamSubjectSetting class="write_exam_query_date"
                       :custom-id="customId"
                       :data-types="dataTypes"
                        studentType="EMBA"
  >
    <template #default="scope">
      <keep-alive>
        <TemplateDataGrid gridId="operaEnrollingExamSubjectList" studentType="EMBA"
                          v-bind="scope"></TemplateDataGrid>
      </keep-alive>
    </template>
  </EnrollExamSubjectSetting>
</template>

<script>
import EnrollExamSubjectSetting from './EnrollExamSubjectSetting'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'EmbaEnrollExamSubject',
  components: {
    EnrollExamSubjectSetting,
    TemplateDataGrid
  },
  data () {
    return {
      dataTypes: ['enrollBatch'],
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
.write_exam_query_date {
  height: 100%;
}
</style>
